var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "big" },
    [
      _c(
        "el-form",
        { attrs: { inline: true, "label-position": "top" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "平台订单号" } },
            [_c("el-input", { attrs: { placeholder: "平台订单号" } })],
            1
          ),
          _c(
            "el-form-item",
            [_c("el-button", { attrs: { type: "primary" } }, [_vm._v("搜索")])],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "my-card" },
        [
          _c("h3", { staticClass: "card-title" }, [
            _vm._v("Transcation Status"),
          ]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6, xs: "24", sm: "21", md: "6" } },
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        title: "Tips",
                        placement: "right",
                        width: "200",
                        trigger: "hover",
                      },
                    },
                    [
                      _c("p", [_vm._v("SUCCESS: 订单成功")]),
                      _c("p", [_vm._v("PROCESSING: 订单结果处理中")]),
                      _c("p", [_vm._v("FAIL: 订单失败")]),
                      _c(
                        "p",
                        {
                          staticClass: "stauts-label",
                          attrs: { slot: "reference" },
                          slot: "reference",
                        },
                        [
                          _vm._v(_vm._s(_vm.$t("search.OrderStatus")) + " "),
                          _c("i", { staticClass: "el-icon-warning" }),
                        ]
                      ),
                    ]
                  ),
                  _c("p", { staticClass: "stauts color1" }, [
                    _vm._v("SUCCESS"),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6, xs: "24", sm: "21", md: "6" } },
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        title: "Tips",
                        placement: "right",
                        width: "200",
                        trigger: "hover",
                      },
                    },
                    [
                      _c("p", [_vm._v("SUCCESS: 订单成功")]),
                      _c("p", [_vm._v("PROCESSING: 订单结果处理中")]),
                      _c("p", [_vm._v("FAIL: 订单失败")]),
                      _c(
                        "p",
                        {
                          staticClass: "stauts-label",
                          attrs: { slot: "reference" },
                          slot: "reference",
                        },
                        [
                          _vm._v("Payment Status "),
                          _c("i", { staticClass: "el-icon-warning" }),
                        ]
                      ),
                    ]
                  ),
                  _c("p", { staticClass: "stauts color1" }, [
                    _vm._v("SUCCESS"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "my-card" },
        [
          _c("h3", { staticClass: "card-title" }, [_vm._v("Order Details")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8, xs: "24", sm: "12", xl: "8" } },
                [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("p", { staticClass: "label" }, [
                      _vm._v("Trade Order ID: "),
                    ]),
                    _c("p", { staticClass: "value" }, [
                      _vm._v("202108090956483190429020"),
                    ]),
                  ]),
                ]
              ),
              _c(
                "el-col",
                { attrs: { span: 8, xs: "24", sm: "12", xl: "8" } },
                [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("p", { staticClass: "label" }, [
                      _vm._v("Merchant Order Id: "),
                    ]),
                    _c("p", { staticClass: "value" }, [
                      _vm._v("jeetorummy_343224_CcLfc"),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8, xs: "24", sm: "12", xl: "8" } },
                [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("p", { staticClass: "label" }, [
                      _vm._v("$t('table.CreationTime'): "),
                    ]),
                    _c("p", { staticClass: "value" }, [
                      _vm._v("2021-08-09 09:56:49"),
                    ]),
                  ]),
                ]
              ),
              _c(
                "el-col",
                { attrs: { span: 8, xs: "24", sm: "12", xl: "8" } },
                [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("p", { staticClass: "label" }, [
                      _vm._v("Completed Time: "),
                    ]),
                    _c("p", { staticClass: "value" }, [
                      _vm._v("2021-08-09 09:59:13"),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8, xs: "24", sm: "12", xl: "8" } },
                [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("p", { staticClass: "label" }, [
                      _vm._v("$t('table.OrderAmount'): "),
                    ]),
                    _c("p", { staticClass: "value" }, [_vm._v("50")]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "my-card" },
        [
          _c("h3", { staticClass: "card-title" }, [_vm._v("Customer Details")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8, xs: "24", sm: "12", xl: "8" } },
                [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("p", { staticClass: "label" }, [_vm._v("Name: ")]),
                    _c("p", { staticClass: "value" }, [_vm._v("suyog")]),
                  ]),
                ]
              ),
              _c(
                "el-col",
                { attrs: { span: 8, xs: "24", sm: "12", xl: "8" } },
                [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("p", { staticClass: "label" }, [_vm._v("Email ID: ")]),
                    _c("p", { staticClass: "value" }, [
                      _vm._v("suyogwadal8@gmail.com"),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8, xs: "24", sm: "12", xl: "8" } },
                [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("p", { staticClass: "label" }, [_vm._v("Phone No: ")]),
                    _c("p", { staticClass: "value" }, [_vm._v("7499775436")]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "my-card" },
        [
          _c("h3", { staticClass: "card-title" }, [_vm._v("Merchant Details")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8, xs: "24", sm: "12", xl: "8" } },
                [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("p", { staticClass: "label" }, [
                      _vm._v("Merchane ID: "),
                    ]),
                    _c("p", { staticClass: "value" }, [_vm._v("10217")]),
                  ]),
                ]
              ),
              _c(
                "el-col",
                { attrs: { span: 8, xs: "24", sm: "12", xl: "8" } },
                [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("p", { staticClass: "label" }, [_vm._v("APP ID: ")]),
                    _c("p", { staticClass: "value" }, [_vm._v("100000360")]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8, xs: "24", sm: "12", xl: "8" } },
                [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("p", { staticClass: "label" }, [
                      _vm._v("Channel Code: "),
                    ]),
                    _c("p", { staticClass: "value" }, [_vm._v("31SPDADK")]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }